const BACKEND = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND}/api`;
const TOKEN_KEY = 'aln_admin_token';

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

const authHeaders = () => ({ Authorization: `Bearer ${getToken()}` });

export async function login(email, password) {
  const res = await fetch(`${API}/auth/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, password }),
  });
  if (!res.ok) {
    const d = await res.json().catch(() => ({}));
    throw new Error(typeof d.detail === 'string' ? d.detail : 'Login failed');
  }
  const data = await res.json();
  setToken(data.token);
  return data;
}

export async function me() {
  const res = await fetch(`${API}/auth/me`, { headers: authHeaders() });
  if (!res.ok) throw new Error('unauthorized');
  return res.json();
}

export async function getDraft() {
  const res = await fetch(`${API}/admin/content`, { headers: authHeaders() });
  if (!res.ok) throw new Error('unauthorized');
  return res.json();
}

export async function saveDraft(data) {
  const res = await fetch(`${API}/admin/content`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...authHeaders() },
    body: JSON.stringify(data),
  });
  if (!res.ok) throw new Error('Save failed');
  return res.json();
}

export async function publish() {
  const res = await fetch(`${API}/admin/publish`, { method: 'POST', headers: authHeaders() });
  if (!res.ok) throw new Error('Publish failed');
  return res.json();
}

export async function changePassword(current_password, new_password) {
  const res = await fetch(`${API}/auth/change-password`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...authHeaders() },
    body: JSON.stringify({ current_password, new_password }),
  });
  if (!res.ok) {
    const d = await res.json().catch(() => ({}));
    throw new Error(typeof d.detail === 'string' ? d.detail : 'Failed');
  }
  return res.json();
}

export async function listUsers() {
  const res = await fetch(`${API}/admin/users`, { headers: authHeaders() });
  if (!res.ok) throw new Error('Could not load users');
  return res.json(); // [{ email, name, role, must_change_password }]
}

export async function resetUserPassword(email) {
  const res = await fetch(`${API}/admin/users/${encodeURIComponent(email)}/reset-password`, {
    method: 'POST',
    headers: authHeaders(),
  });
  if (!res.ok) {
    const d = await res.json().catch(() => ({}));
    throw new Error(typeof d.detail === 'string' ? d.detail : 'Reset failed');
  }
  return res.json(); // { email, temp_password }
}

export async function getActivityLog() {
  const res = await fetch(`${API}/admin/activity-log`, { headers: authHeaders() });
  if (!res.ok) throw new Error('Could not load activity log');
  return res.json(); // [{ id, timestamp, email, role, action, sections }]
}

export async function uploadImage(file) {
  const fd = new FormData();
  fd.append('file', file);
  const res = await fetch(`${API}/admin/upload`, { method: 'POST', headers: authHeaders(), body: fd });
  if (!res.ok) throw new Error('Upload failed');
  return res.json(); // { url, path }
}

export async function listFiles() {
  const res = await fetch(`${API}/admin/files`, { headers: authHeaders() });
  if (!res.ok) throw new Error('Could not load library');
  return res.json(); // [{ url, path, created_at }]
}

export async function listGiftCards() {
  const res = await fetch(`${API}/admin/gift-cards`, { headers: authHeaders() });
  if (!res.ok) throw new Error('Could not load gift cards');
  return res.json();
}

export async function adjustGiftCard(code, balance) {
  const res = await fetch(`${API}/admin/gift-cards/${code}/adjust`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...authHeaders() },
    body: JSON.stringify({ balance }),
  });
  if (!res.ok) throw new Error('Could not update gift card');
  return res.json();
}

export const fullUrl = (u) => (u && u.startsWith('/api/') ? `${BACKEND}${u}` : u);
